//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
export default {
  name: 'dialog-box',
  data () {
    return {
      showDialog: true,
      type: 'text',
      title: '',
      text: '',
      ptext: '',
      showCancelBtn: true,
      confirmText: '确定',
      cancelText: '取消',
      placeholder: '',
      theme: '#F64C4C',
      confirm: null,
      cancel: null,
      list: []
    }
  },
  methods: {
    cancelClick () {
      try {
        this.cancel(this.text);
      } catch (e) {

      }
      this.showDialog = false;
    },
    confirmClick () {
      if (this.type === 'select' && !this.text) {
        return
      }
      try {
        this.confirm(this.text);
      } catch (e) {

      }
      this.showDialog = false;
    },
    toSelect (item) {
      for (var i in this.list) {
        this.$set(this.list[i], 'isSelect', false)
      }
      this.$set(item, 'isSelect', true)
      this.text = item
    }
  },
  mounted () {
    this.text = this.content
    if (this.type === 'textarea') {
      this.$nextTick(() => {
        document.getElementById('tex').focus()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dialog/src/main.vue